import $ from "jquery";

document.addEventListener('DOMContentLoaded', function() {
  const playVideoLink = document.getElementById('play-video-link');
  const videoPopup = document.getElementById('video-popup');
  const closePopupButton = document.querySelector('.video-popup-close');
  
  if (playVideoLink) {
      playVideoLink.addEventListener('click', function(e) {
          e.preventDefault();
          videoPopup.style.display = 'flex';
          console.log('gobacktostart now');
          const video = $('.video-popup video')[0]; // Get the video element             // Pause the video
            video.currentTime = 0; 

      });
  }

  if (closePopupButton) {
      closePopupButton.addEventListener('click', function() {
          videoPopup.style.display = 'none';
          const videoPlayer = document.getElementById('video-player');
          if (videoPlayer) {
              videoPlayer.pause();
              videoPlayer.currentTime = 0;
          }
      });
  }

  // Close popup when clicking outside the popup content
  window.addEventListener('click', function(e) {
      if (e.target === videoPopup) {
          videoPopup.style.display = 'none';
          const videoPlayer = document.getElementById('video-player');
          if (videoPlayer) {
              videoPlayer.pause();
              videoPlayer.currentTime = 0;
          }
      }
  });
});